var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{attrs:{"id":_vm.id,"width":"400","height":"100"}})])}
var staticRenderFns = []

export { render, staticRenderFns }